
// frontend/modules/account-settings/views/CashBankManagement.tsx
import React from 'react';
import { Card, Typography } from 'antd';
import { useTheme } from '@/components/common/ThemeProvider';
import { TransaccForm } from '../components/TransaccForm';
import { TransaccList } from '../components/TransaccList';
import { useTransaccManagement } from '../hooks/useTransaccManagement';
import { useMessage } from '@/shared/hooks/useMessage';
import {TransaccFormData} from "@/modules/account-settings/types";

const { Title } = Typography;

export const CashBankManagement: React.FC = () => {
    const { dark } = useTheme();
    const message = useMessage();
    const {
        coaList,
        transaccList,
        selectedGl,
        setSelectedGl,
        accountType,
        setAccountType,
        handleCreate,
        handleUpdate,
        handleDelete,
        isLoading
    } = useTransaccManagement();

    const handleSubmit = async (data: TransaccFormData) => {
        try {
            await handleCreate({
                ...data,
                glNo: selectedGl,  // ensure selected values are included
                acctype: accountType
            });
            message.success('Account created successfully');
        } catch (error) {
            console.error('Creation failed:', error);
            message.error('Failed to create account');
        }
    };

    return (
        <div className="space-y-4">
            <Title level={2} className={dark ? 'text-white' : ''}>
                Define Cash / Bank / Transfer
            </Title>

            <Card className={dark ? 'bg-gray-800' : ''}>
                <TransaccForm
                    coaList={coaList}
                    onSubmit={handleSubmit}
                    selectedGl={selectedGl}
                    setSelectedGl={setSelectedGl}
                    accountType={accountType}
                    setAccountType={setAccountType}
                    loading={isLoading}
                />
            </Card>

            <Card className={dark ? 'bg-gray-800' : ''}>
                <TransaccList
                    data={transaccList}
                    onEdit={handleUpdate}
                    onDelete={handleDelete}
                    loading={isLoading}
                />
            </Card>
        </div>
    );
};
